var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "DDTStatsModal",
        title: "Statistic Report",
        "content-class": "modal-content-full",
        "dialog-class": "modal-dialog-full",
        "modal-header-class": "ptv-modal-header",
        size: "xl",
        centered: "",
        scrollable: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.reset()
        },
        show: function ($event) {
          return _vm.generateStatistics()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between w-100",
                },
                [
                  _c(
                    "h5",
                    { staticClass: "mb-0 font-weight-semibold text-white" },
                    [_vm._v("Statistic Report")]
                  ),
                  _vm._v(" "),
                  !_vm.dataLoading
                    ? _c(
                        "span",
                        {
                          staticClass: "download-button-container",
                          on: { click: _vm.downloadReports },
                        },
                        [
                          _c("fa", {
                            attrs: { icon: ["fas", "download"], size: "lg" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-row",
                { staticClass: "w-100 justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "close-btn px-4 py-2",
                      on: {
                        click: function ($event) {
                          return _vm.closeStatsModal()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "ddt-form-area" }, [
        _c("div", { staticClass: "ddt-form-row" }, [
          _c(
            "div",
            { staticClass: "ddt-field ddt-field--type" },
            [
              _c("label", { staticClass: "ddt-form-label" }, [
                _vm._v("Delivery Type"),
              ]),
              _vm._v(" "),
              _c(
                "b-form-select",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "first",
                      fn: function () {
                        return [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: null, disabled: "" } },
                            [_vm._v("Select Type")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.deliveryType,
                    callback: function ($$v) {
                      _vm.deliveryType = $$v
                    },
                    expression: "deliveryType",
                  },
                },
                [
                  _vm._v(" "),
                  _c("b-form-select-option", { attrs: { value: "INPX" } }, [
                    _vm._v("INPX"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ddt-field ddt-field--date" },
            [
              _c("label", { staticClass: "ddt-form-label text-nowrap" }, [
                _vm._v("Requested Delivery Date"),
              ]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: {
                  type: "date",
                  placeholder: "Select date",
                  format: "yyyy/mm/dd",
                },
                model: {
                  value: _vm.deliveryDate,
                  callback: function ($$v) {
                    _vm.deliveryDate = $$v
                  },
                  expression: "deliveryDate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ddt-field ddt-field--notes" },
            [
              _c("label", { staticClass: "ddt-form-label" }, [_vm._v("Notes")]),
              _vm._v(" "),
              _c("b-form-textarea", {
                attrs: { rows: "1", "max-rows": "3" },
                model: {
                  value: _vm.note,
                  callback: function ($$v) {
                    _vm.note = $$v
                  },
                  expression: "note",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.statsObjs.length
        ? _c("div", { staticClass: "stats-dash" }, [
            _c(
              "div",
              { staticClass: "stats-dash__head" },
              [
                _c("span", { staticClass: "ddt-section-title" }, [
                  _vm._v("Statistical Analysis"),
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.isCellsLoading
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "stats-loading-banner d-flex align-items-center",
                        },
                        [
                          _c("span", {
                            staticClass:
                              "spinner-border spinner-border-sm loading-banner-spinner mr-2",
                            attrs: { role: "status" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "loading-banner-text" }, [
                            _vm._v("Statistics are loading…"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.statsObjs.length > 1 || _vm.showRequestBtn
              ? _c(
                  "div",
                  { staticClass: "stats-toolbar" },
                  [
                    _vm.statsObjs.length > 1
                      ? _c(
                          "div",
                          { staticClass: "stats-samples" },
                          _vm._l(_vm.statsObjs, function (statsObj, index) {
                            return _c(
                              "button",
                              {
                                key: "tab-" + index,
                                staticClass: "stats-sample-tab",
                                class: {
                                  "stats-sample-tab--active":
                                    _vm.activeSample === index,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.activeSample = index
                                  },
                                },
                              },
                              [_vm._v("Sample " + _vm._s(index + 1))]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showRequestBtn
                      ? _c(
                          "b-button",
                          {
                            staticClass: "request-btn stats-toolbar__request",
                            attrs: {
                              disabled: _vm.dataLoading,
                              variant: "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openConfirmation(
                                  _vm.statsObjs[_vm.activeSample],
                                  _vm.activeSample
                                )
                              },
                            },
                          },
                          [
                            _c("fa", {
                              staticClass: "request-btn__icon",
                              attrs: { icon: ["fas", "paper-plane"] },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Request" +
                                  _vm._s(
                                    _vm.statsObjs.length > 1
                                      ? " Sample " + (_vm.activeSample + 1)
                                      : ""
                                  )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.summarySection
              ? _c(
                  "div",
                  { staticClass: "stat-card stat-card--summary stat-summary" },
                  [
                    _c(
                      "div",
                      { staticClass: "stat-card__head" },
                      [
                        _c("fa", {
                          staticClass: "stat-card__icon",
                          attrs: { icon: ["fas", _vm.summarySection.icon] },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-card__title" }, [
                          _vm._v(_vm._s(_vm.summarySection.label)),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stat-summary__row" },
                      _vm._l(_vm.summarySection.metrics, function (metric) {
                        return _c(
                          "div",
                          {
                            key: metric.key,
                            staticClass: "stat-summary__item",
                          },
                          [
                            _c("span", { staticClass: "stat-summary__label" }, [
                              _vm._v(_vm._s(metric.label)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "stat-summary__value" }, [
                              _vm.statsObjs[_vm.activeSample] &&
                              _vm.statsObjs[_vm.activeSample][metric.key] !==
                                undefined
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.statsObjs[_vm.activeSample][
                                          metric.key
                                        ]
                                      )
                                    ),
                                  ])
                                : _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm cell-spinner",
                                    attrs: { role: "status" },
                                  }),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stats-cards" },
              _vm._l(_vm.statColumns, function (column, ci) {
                return _c(
                  "div",
                  { key: ci, staticClass: "stat-col" },
                  _vm._l(column, function (section) {
                    return _c(
                      "div",
                      {
                        key: section.label,
                        staticClass: "stat-card",
                        class: {
                          "stat-card--summary": section.label === "Summary",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "stat-card__head" },
                          [
                            _c("fa", {
                              staticClass: "stat-card__icon",
                              attrs: { icon: ["fas", section.icon] },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "stat-card__title" }, [
                              _vm._v(_vm._s(section.label)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "stat-card__body" },
                          _vm._l(section.metrics, function (metric) {
                            return _c(
                              "div",
                              { key: metric.key, staticClass: "stat-line" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "stat-line__label" },
                                  [_vm._v(_vm._s(metric.label))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "stat-line__value" },
                                  [
                                    _vm.statsObjs[_vm.activeSample] &&
                                    _vm.statsObjs[_vm.activeSample][
                                      metric.key
                                    ] !== undefined
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.statsObjs[_vm.activeSample][
                                                metric.key
                                              ]
                                            )
                                          ),
                                        ])
                                      : _c("span", {
                                          staticClass:
                                            "spinner-border spinner-border-sm cell-spinner",
                                          attrs: { role: "status" },
                                        }),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  0
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "confirmSampleRequest",
            size: "md",
            "content-class": "sub-menu-transparent",
            title: "Data Request Confirmation",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between w-100",
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "mb-0 font-weight-semibold text-white" },
                        [_vm._v("Data Request Confirmation")]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-row",
                    { staticClass: "w-100 justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "close-btn px-4 py-2",
                          on: {
                            click: function ($event) {
                              return _vm.closeConfirmation()
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "py-2 text-center" },
                [
                  _c("b-col", [
                    _vm._v(
                      "\n                    Data request with total segments length of "
                    ),
                    _c("b", { staticClass: "highlight" }, [
                      _vm._v(
                        _vm._s(_vm.requestedSample["All segments length"])
                      ),
                    ]),
                    _vm._v(" will be sent to DMP.\n                "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "py-2 text-center" },
                [
                  _c("b-col", [
                    _vm._v(
                      "Please confirm and click submit to send the request."
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass: "py-2 w-100 justify-content-center",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "confirm-btn px-3 py-2",
                      on: {
                        click: function ($event) {
                          return _vm.submitRequest()
                        },
                      },
                    },
                    [_vm._v("Submit")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }